import { API_ENDPOINTS } from '../constants/endpoints';
import { post } from '../utils/api.utils';

export interface CjEventRequest {
  cjeventId: string;
  companyId: string;
  email: string;
}

export interface CjGenericResponse<TData = unknown> {
  data: TData;
  timestamp: string;
  status: number;
}

class CJService {
  public static async sendSampleEvent(): Promise<CjGenericResponse> {
    return this.sendEvent({
      cjeventId: 'cb2d3f702de811f1831500970a18ba72',
      companyId: 'd7ab519c-fa90-4184-8e64-65e61aa16a70',
      email: 'user@example.com',
    });
  }

  public static async sendEvent<TData = unknown>(
    payload: CjEventRequest,
  ): Promise<CjGenericResponse<TData>> {
    try {
      const response = await post<CjGenericResponse<TData>>(
        API_ENDPOINTS.CJ.SEND_EVENT,
        payload,
      );

      console.info('[CJService] CJ event sent successfully', {
        cjeventId: payload.cjeventId,
        companyId: payload.companyId,
      });

      return response;
    } catch (error) {
      console.error('[CJService] Failed to send CJ event', {
        cjeventId: payload.cjeventId,
        companyId: payload.companyId,
        error,
      });
      throw error;
    }
  }
}

export default CJService;
